import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {StoreService} from '../../services/http/store/store.service';
import {StoreDetails} from '../../classes/models/store/StoreDetails';
import {DataService} from '../../services/store/data.service';
import {Authority} from '../../classes/enums/Authority';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../shared/standalone-imports";
import {DefaultWorkingTimesComponent} from "./default-working-times/default-working-times.component";
import {SpecificWorkingTimesComponent} from "./specific-working-times/specific-working-times.component";
import {EmployeeRequirementsComponent} from "./employee-requirements/employee-requirements.component";
import {BankingSettingsComponent} from "./banking-settings/banking-settings.component";
import {StoreClosureComponent} from "./store-closure/store-closure.component";

/**
 * This component displays a store details page.
 */
@Component({
  selector: 'app-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.less'],
  imports: [SHARED_IMPORTS, DefaultWorkingTimesComponent, SpecificWorkingTimesComponent, EmployeeRequirementsComponent, BankingSettingsComponent, StoreClosureComponent]
})
export class StoreDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private storeService = inject(StoreService);
  dataService = inject(DataService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** Detailed information about a selected store. */
  store: StoreDetails;
  /** Assign an Authority, so it could be used in HTML. */
  Authority = Authority;

  /**
   * Retrieve store details and edit date from backend when an id in the route changes.
   */
  ngOnInit(): void {
    this.route.params
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                this.getStoreDetails();
              }
            });
  }

  /**
   * Retrieves store details from backend.
   */
  getStoreDetails(): void {
    const storeSlug = this.route.snapshot.paramMap.get('id');
    this.storeService.getDetails(storeSlug)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: store => {
                this.store = store;
                this.dataService.editDate = store.firstEditableDate;
              }
            });
  }
}

